import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import { DrawerState } from 'common/entities/drawer/DrawerTypes';
import companyIcon from 'common/assets/svg/common/company.svg';
import IconSelect from 'common/components/form/styled-inputs/IconSelect';

import { fetchListOptions } from 'store/lists/actions';
import { selectListDefaultOptions } from 'store/lists/selectors';

import Table from './Table';

const Equivalent = ({ id, drawer }) => {
  const organizationsList = useSelector(state => selectListDefaultOptions(state, 'organizations'));
  const [organizationId, setOrganizationId] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListOptions('organizations'));
  }, [dispatch]);

  useEffect(() => {
    if (drawer?.isOpen && organizationsList?.length) {
      setOrganizationId(organizationsList[0]?.id);
    }

    if (!drawer?.isOpen) {
      setOrganizationId();
    }
  }, [drawer?.isOpen, organizationsList]);

  const onChange = value => {
    setOrganizationId(value);
  };

  return (
    <Row>
      <Col xs={3}>
        <IconSelect
          options={organizationsList}
          isMulti={false}
          isClearable={false}
          getOptionValue={v => v.id}
          getOptionLabel={v => v.name}
          onChange={onChange}
          value={organizationId}
          icon={companyIcon}
          size="sm"
        />
      </Col>

      <Col xs={12}>
        {organizationId && id ? (
          <Table key={organizationId} organizationId={organizationId} storeGroupId={id} />
        ) : null}
      </Col>
    </Row>
  );
};

export default Equivalent;

Equivalent.propTypes = {
  id: PropTypes.number.isRequired,
  drawer: DrawerState
};
